<button
    class="bg-transparent border-0 flex items-center gap-0 cursor-pointer"
    id="change-status"
    data-testid="details-header-button-change-status"
>
    <sh-text>{{ 'request.requestDetail.changeStatus' | translate }}</sh-text>
    <sh-icon icon="arrow-line-down-s"></sh-icon>
</button>
<sh-popover target="change-status" position="bottom">
    @if (request().status === states.SUBMITTED) {
        <sh-menu-item
            data-testid="details-status-menu-option-assign-to"
            [toggle]="false"
            label="{{ 'request.requestDetail.assignTo' | translate }}"
            (click)="handleAssignTo()"
        >
        </sh-menu-item>
    }
    @if (canPutOnHold()) {
        <sh-menu-item
            data-testid="details-status-menu-option-put-on-hold"
            [toggle]="false"
            label="{{ 'request.requestDetail.putOnHold' | translate }}"
            (click)="handlePutRequestOnHoldDialog()"
        >
        </sh-menu-item>
    }
    @if (canSetActive()) {
        <sh-menu-item
            data-testid="details-status-menu-option-set-active"
            [toggle]="false"
            label="{{ 'request.requestDetail.setActive' | translate }}"
            (click)="handleOpenSetRequestActiveDialog()"
        >
        </sh-menu-item>
    }
    @if (canShowUnderReviewButton()) {
        <sh-menu-item
            data-testid="details-status-menu-option-assign-request"
            [toggle]="false"
            label="{{ 'request.requestDetail.assign' | translate }}"
            (click)="handleAsignRequest()"
        >
        </sh-menu-item>
    }
    @if (canReassign()) {
        <sh-menu-item
            data-testid="details-status-menu-option-reassign"
            [toggle]="false"
            label="{{ 'request.requestDetail.reassign-request' | translate }}"
            (click)="handleOpenReassignRequestDialog()"
        >
        </sh-menu-item>
    }
    @if (canShowPendingCustomerActionButton()) {
        <sh-menu-item
            data-testid="details-status-menu-option-request-feedback"
            [toggle]="false"
            label="{{ 'request.requestDetail.demandCustomerFeedback' | translate }}"
            (click)="handleOpenDemandCustomerFeedbackDialog()"
        >
        </sh-menu-item>
    }
    @if (canShowReferredOutButton()) {
        <sh-menu-item
            data-testid="details-status-menu-option-refer-out-email"
            [toggle]="false"
            label="{{ 'request.requestDetail.referOut-external' | translate }}"
            (click)="handleOpenExternalReferOutDialog()"
        >
        </sh-menu-item>
        <sh-menu-item
            data-testid="details-status-menu-option-refer-out-mdla-team"
            [toggle]="false"
            label="{{ 'request.requestDetail.referOut-internal' | translate }}"
            (click)="handleOpenInternalReferOutDialog()"
        >
        </sh-menu-item>
    }
    @if (canShowClosedButton()) {
        <sh-menu-item
            data-testid="details-status-menu-option-mark-resolved"
            [toggle]="false"
            label="{{ 'request.requestDetail.markRequestResolved' | translate }}"
            (click)="handleOpenCloseRequestDialog()"
        >
        </sh-menu-item>
    }
</sh-popover>
